export default "__VITE_ASSET__WmSN05oJ__"